import Layout from "../../common/layout/Layout";
import "./Tags.scss";

export default function Tags() {
  return <Layout>Tags</Layout>;
}
